// extracted by mini-css-extract-plugin
module.exports = {"header":"MenuHeader_header__oOImQ","title":"MenuHeader_title__iRM_w","closeButton":"MenuHeader_closeButton__eLjW4"};